import { render, staticRenderFns } from "./ExtensionsList.vue?vue&type=template&id=7bf042ec"
import script from "./ExtensionsList.vue?vue&type=script&lang=js"
export * from "./ExtensionsList.vue?vue&type=script&lang=js"
import style0 from "./ExtensionsList.vue?vue&type=style&index=0&id=7bf042ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports